module.exports = __webpack_public_path__ + "static/media/check.beb53e7a.svg";